import {
  GET_LABREQUESTREPORTAUX,
  GET_LABREQUESTREPORTAUX_FAIL,
  GET_LABREQUESTREPORTAUX_SUCCESS,
  GET_LABREQUESTREPORTAUXS,
  GET_LABREQUESTREPORTAUXS_FAIL,
  GET_LABREQUESTREPORTAUXS_SUCCESS,
  ADD_NEW_LABREQUESTREPORTAUX,
  ADD_LABREQUESTREPORTAUX_SUCCESS,
  ADD_LABREQUESTREPORTAUX_FAIL,
  UPDATE_LABREQUESTREPORTAUX,
  UPDATE_LABREQUESTREPORTAUXCHECK,
  UPDATE_LABREQUESTREPORTAUX_SUCCESS,
  UPDATE_LABREQUESTREPORTAUX_FAIL,
  DELETE_LABREQUESTREPORTAUX,
  DELETE_LABREQUESTREPORTAUX_SUCCESS,
  DELETE_LABREQUESTREPORTAUX_FAIL,
  SET_STATE_LABREQUESTREPORTAUX
} from "./actionTypes"

export const setState = ( loading ) => ({
  type: SET_STATE_LABREQUESTREPORTAUX,
  payload: loading,
})

export const getLabRequestReportAuxs = ( params ) => ({
  type: GET_LABREQUESTREPORTAUXS,
  payload: { params },
})

export const getLabRequestReportAuxsSuccess = (labRequestReportAuxs, totalPages, currentPage) => ({
  type: GET_LABREQUESTREPORTAUXS_SUCCESS,
  payload: { labRequestReportAuxs:labRequestReportAuxs, total:totalPages, currentPage:currentPage}
})

export const getLabRequestReportAuxsFail = error => ({
  type: GET_LABREQUESTREPORTAUXS_FAIL,
  payload: error,
})

export const addNewLabRequestReportAux = labRequestReportAux => ({
  type: ADD_NEW_LABREQUESTREPORTAUX,
  payload: labRequestReportAux,
})

export const addLabRequestReportAuxSuccess = labRequestReportAux => ({
  type: ADD_LABREQUESTREPORTAUX_SUCCESS,
  payload: labRequestReportAux,
})  

export const addLabRequestReportAuxFail = error => ({
  type: ADD_LABREQUESTREPORTAUX_FAIL,
  payload: error,
})

export const updateLabRequestReportAux = labRequestReportAux => ({
  type: UPDATE_LABREQUESTREPORTAUX,
  payload: labRequestReportAux,
})

export const updateLabRequestReportAuxSuccess = labRequestReportAux => ({
  type: UPDATE_LABREQUESTREPORTAUX_SUCCESS,
  payload: labRequestReportAux,
})

export const updateLabRequestReportAuxFail = error => ({
  type: UPDATE_LABREQUESTREPORTAUX_FAIL,
  payload: error,
})

export const updateLabRequestSampleCheck = (id, checkValue) => ({
  type: UPDATE_LABREQUESTREPORTAUXCHECK,
  payload: { id:id, checked:checkValue },
})

export const deleteLabRequestReportAux = labRequestReportAux => ({
  type: DELETE_LABREQUESTREPORTAUX,
  payload: labRequestReportAux,
})

export const deleteLabRequestReportAuxSuccess = id => ({
  type: DELETE_LABREQUESTREPORTAUX_SUCCESS,
  id,
})

export const deleteLabRequestReportAuxFail = error => ({
  type: DELETE_LABREQUESTREPORTAUX_FAIL,
  payload: error,
})

export const getLabRequestReportAux = () => ({
  type: GET_LABREQUESTREPORTAUX,
})

export const getLabRequestReportAuxSuccess = labRequestReportAux => ({
  type: GET_LABREQUESTREPORTAUX_SUCCESS,
  payload: labRequestReportAux,
})

export const getLabRequestReportAuxFail = error => ({
  type: GET_LABREQUESTREPORTAUX_FAIL,
  payload: error,
})
